export function SalliSvg() {
    return {
        restrict: 'E',
        scope: true,
        template: `<ng-include class="d-contents" src="'../hui/modules/svg/salli.svg'"></ng-include>`
    }
}
